import React from 'react';
import Chip, { ChipProps } from '@mui/material/Chip';
import { styled } from '@mui/material/styles';

export type StatusChipTone = 'neutral' | 'brandLight' | 'brandDark';

export type StatusChipProps = Omit<ChipProps, 'size'> & {
  tone?: StatusChipTone;
};

const StatusChipRoot = styled(Chip, {
  shouldForwardProp: prop => prop !== 'tone',
})<{ tone: StatusChipTone }>(({ theme, tone }) => {
  const fill =
    tone === 'brandLight'
      ? theme.palette.primary.light
      : tone === 'brandDark'
        ? theme.palette.primary.dark
        : null;

  return {
    ...theme.typography.caption,
    ...(fill && { backgroundColor: fill, color: theme.palette.getContrastText(fill) }),
  };
});

export const StatusChip = ({ tone = 'neutral', ...props }: StatusChipProps) => (
  <StatusChipRoot size="small" tone={tone} {...props} />
);
